import React from "react";
import { Box, Typography } from "@mui/material";

const OfficeLocation = () => {
  return (
    <Box
      component="section"
      sx={{
        py: 4,
        px: 2,
        background: "linear-gradient(135deg, #f8fdfc 0%, #ffffff 100%)",
      }}
    >
      {/* Title Section */}
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          textAlign: "center",
          mb: 4,
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "2rem", md: "3rem" },
            color: "#018f87",
            mb: 1,
            fontFamily: "Montserrat, sans-serif",
          }}
        >
          Our Office Location
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#444",
            maxWidth: 700,
            mx: "auto",
            lineHeight: 1.6,
            fontSize: "1.1rem",
          }}
        >
          We welcome you to visit our office and connect with our team.  
          Our headquarters is located in the heart of Bengaluru, surrounded by a vibrant and growing community.
        </Typography>
      </Box>

      {/* Map Section */}
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          borderRadius: 4,
          overflow: "hidden",
          boxShadow: "0 6px 25px rgba(0,0,0,0.15)",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          "&:hover": {
            transform: "scale(1.01)",
            boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
          },
        }}
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d13017.912545153229!2d77.587694!3d13.025944!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTPCsDAxJzMzLjQiTiA3N8KwMzUnMTUuNyJF!5e1!3m2!1sen!2sus!4v1761652459820!5m2!1sen!2sus"
          width="100%"
          height="500"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Office Location"
        ></iframe>
      </Box>
    </Box>
  );
};

export default OfficeLocation;
